import React, { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { getNextMonth } from "../../../Utils/Utils";
import { CurrencyDisplay, KgDisplay } from "../../../Utils/Inputs";

export default function SolidosTotalesRows(props) {
    const { monthIndex, isFirstTable, month, ctoPromedioDelInvenTotalKgSecos, ctoPromedioDelInvenTotalValorTotal } = props;

    const { setValue } = useFormContext();

    // Cto. Promedio del Inven. Total
    const ctoPromedioDelInvenTotalCostoKgSecos = useMemo(() => (ctoPromedioDelInvenTotalValorTotal / ctoPromedioDelInvenTotalKgSecos), [ctoPromedioDelInvenTotalValorTotal, ctoPromedioDelInvenTotalKgSecos]);

    // Salidas a producción
    const salidasProdKgSecos = useMemo(() => ctoPromedioDelInvenTotalKgSecos, [ctoPromedioDelInvenTotalKgSecos]);
    const salidasProdCostoKgSecos = useMemo(() => ctoPromedioDelInvenTotalCostoKgSecos, [ctoPromedioDelInvenTotalCostoKgSecos]);
    const salidasProdValorTotal = useMemo(() => salidasProdKgSecos * salidasProdCostoKgSecos, [salidasProdKgSecos, salidasProdCostoKgSecos]);

    // Inventario Final
    const invenFinalKgSecos = useMemo(() => ctoPromedioDelInvenTotalKgSecos - salidasProdKgSecos, [ctoPromedioDelInvenTotalKgSecos, salidasProdKgSecos]);
    const invenFinalCostoKgSecos = useMemo(() => ctoPromedioDelInvenTotalCostoKgSecos, [ctoPromedioDelInvenTotalCostoKgSecos]);
    const invenFinalValorTotal = useMemo(() => invenFinalKgSecos * invenFinalCostoKgSecos, [invenFinalKgSecos, invenFinalCostoKgSecos]);

    // Actualizar salidas a producción porque se utilizan en Costo de Ventas en SOLIDOS
    useEffect(() => {
        // Salidas a producción
        setValue(`ComparativoCostoMP.SolidosData.SalidasAProduccion.${month}.KgSecos`, salidasProdKgSecos);
        setValue(`ComparativoCostoMP.SolidosData.SalidasAProduccion.${month}.CostoKgSec`, salidasProdCostoKgSecos);
        setValue(`ComparativoCostoMP.SolidosData.SalidasAProduccion.${month}.Total`, salidasProdValorTotal);
    }, [salidasProdKgSecos, salidasProdCostoKgSecos, salidasProdValorTotal, month, setValue]);

    // Actualizar inventarios iniciales de meses posteriores
    useEffect(() => {
        const nextMonth = getNextMonth(monthIndex);
        if (nextMonth === 'enero') return;

        setValue(`ComparativoCostoMP.SolidosData.InventarioInicial.${nextMonth}.KgSecos`, invenFinalKgSecos);
        setValue(`ComparativoCostoMP.SolidosData.InventarioInicial.${nextMonth}.CostoKgSec`, ctoPromedioDelInvenTotalCostoKgSecos);
    }, [invenFinalKgSecos, ctoPromedioDelInvenTotalCostoKgSecos, month, setValue]);

    return (
        <React.Fragment>
            <tr className='celda-totales'>
                {/* Cto. Promedio del Inven. Total */}
                <td><KgDisplay value={ctoPromedioDelInvenTotalKgSecos} /></td>
                <td><CurrencyDisplay value={ctoPromedioDelInvenTotalCostoKgSecos} decimalScale={5} /></td>
                <td><CurrencyDisplay value={ctoPromedioDelInvenTotalValorTotal} /></td>
            </tr>
            <tr>
                {/* Salidas a producción */}
                <td><KgDisplay value={salidasProdKgSecos} /></td>
                <td><CurrencyDisplay value={salidasProdCostoKgSecos} decimalScale={5} /></td>
                <td><CurrencyDisplay value={salidasProdValorTotal} /></td>
            </tr>
            <tr className='celda-totales'>
                {/* Inventario Final */}
                <td><KgDisplay value={invenFinalKgSecos} /></td>
                <td><CurrencyDisplay value={invenFinalCostoKgSecos} decimalScale={5} /></td>
                <td><CurrencyDisplay value={invenFinalValorTotal} /></td>
            </tr>
        </React.Fragment>
    );
}
